import { render, staticRenderFns } from "./pay-jxf.vue?vue&type=template&id=df0177aa&scoped=true"
import script from "./pay-jxf.vue?vue&type=script&lang=js"
export * from "./pay-jxf.vue?vue&type=script&lang=js"
import style0 from "./pay-jxf.vue?vue&type=style&index=0&id=df0177aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0177aa",
  null
  
)

export default component.exports